module.exports = __webpack_public_path__ + "static/icon_item3.15012777.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/serviceProvider/icon_item3.png
// module id = 1043
// module chunks = 2